<template>
  <payout-form-group :label="defaultLabel"
                     :class="groupClass"
                     :required="required || model.isRequiredAttribute(attribute)"
                     :has-errors="model.errors.has(ea)">
    <filtered-input-wrapper :disabled="disabled" v-model="value" @start-edit="onFilteredStartEdit">
      <input :type="type" class="form-control"
             :name="attribute"
             ref="defaultInput"
             @keyup.enter="onKeyupEnter"
             :disabled="disabled"
             v-model="value"/>
    </filtered-input-wrapper>
    <payout-input-hint-block v-slot:hints :hint="hint ? hint : model.getHint(attribute)"></payout-input-hint-block>
    <error-message-block v-slot:errors :attribute="ea" :errors="model.errors"></error-message-block>
  </payout-form-group>
</template>

<script lang="ts">
import Vue from "vue";
import {Component, Prop} from "vue-property-decorator";
import ErrorMessageBlock from "@/components/forms/payout/ErrorMessageBlock.vue";
import PayoutInputHintBlock from "@/components/forms/payout/PayoutInputHintBlock.vue";
import PayoutFormGroup from "@/components/forms/payout/PayoutFormGroup.vue";
import FilteredInputWrapper from "@/components/forms/payout/forms/inputs/FilteredInputWrapper.vue";
import {PayoutWebModel} from "capitalist-shared/src/finance/payments";

@Component({
  name: "PayoutTextfieldInputGroup",
  components: {FilteredInputWrapper, PayoutFormGroup, PayoutInputHintBlock, ErrorMessageBlock}
})
export default class PayoutTextfieldInputGroup extends Vue {
  @Prop({default: null})
  hint: string | null

  @Prop({required: true})
  model: PayoutWebModel

  @Prop({default: 'text'})
  type: string

  @Prop({default: 'description'})
  attribute: string

  @Prop({default: null})
  errorsAttribute: string | null

  @Prop({default: false})
  required: boolean

  @Prop({default: false})
  disabled: boolean

  @Prop({default: true})
  preventEnter: boolean

  @Prop({default: null})
  label: string | null

  @Prop({default: true})
  filterable: boolean

  get defaultLabel() {
    const labels = {
      'description': 'Назначение',
    }
    const result = this.label ? this.label : this.model.getLabel(this.attribute);
    if (result) {
      if ((result === this.attribute) && !!labels[result])
      {
        return this.$t(labels[this.attribute]);
      }
      return this.$t(result);
    }

    return labels[this.attribute] ? this.$t(labels[this.attribute]) : labels[this.attribute];
  }

  onFilteredStartEdit() {
    this.$nextTick(() => {
      if (this.$refs.defaultInput)
      {
        (this.$refs.defaultInput as any).focus();
      }
    });
  }

  onKeyupEnter(e: any) {
    if (this.preventEnter) {
      this.$emit('keydown-enter-prevented');
      e.preventDefault();
      return false;
    }
    this.$emit('keydown-enter');
  }

  get value() {
    return this.model.values[this.attribute];
  }

  set value(v) {
    Vue.set(this.model.values, this.attribute, v);
  }

  get ea(): string {
    return this.errorsAttribute ? this.errorsAttribute : this.attribute;
  }

  get groupClass() {
    return {
      "form-group__label_align_start": this.filterable
    }
  }
}
</script>

<style scoped>

</style>


<i18n>
{
  "en": {
    "Назначение": "Description"
  }
}
</i18n>
